<template>
  <custom-dialog width="1000px" :title="model.title" :visible="visible" v-on="$listeners" class="device-test-dialog">
    <div class="dialog-body">
      <div class="device-header">
        <div class="device-id">{{ 'Modem SN' }}：{{ model.data.modemSn }}</div>
        <div class="device-temp" style="margin-left: 30px; float: left">
          <div class="key">{{ $t('dms_device_test_dialog.ce_shi_shi_wen') }}：</div>
          <div class="val">
            <el-input-number v-model="temp"></el-input-number>
          </div>
        </div>
        <div class="device-temp">
          <el-button @click="refreshPage" style="float: right">
            <i class="icon icon-shuaxin"></i>
            {{ $t('dms_device_test_dialog.shua_xin_ye_mian') }}
          </el-button>
        </div>
        <div class="device-temp" style="margin-right: 20px">
          <el-button @click="refreshCompoment" style="float: right" :disabled="asyncing">
            <i class="icon icon-shuaxin"></i>
            {{ $t('dms_device_test_dialog.ji_qi_shu_ju') }}
            <span v-if="asyncing">（{{ $t('dms_device_test_dialog.shua_xin_zhong') }}... ）</span>
          </el-button>
        </div>
        <div class="device-time" style="margin-right: 20px">{{ $t('dms_device_test_dialog.sjgxsj') }}：{{ momentAmPm($momentLocal(modemSnInfo.lastDataUpdateTime)) }}</div>
      </div>
      <div class="table-bd">
        <custom-table :data="tableList" :column="tableColumn" height="100%" :index="true" :border="true" :span-method="objectSpanMethod" :slots="['isNormal', 'langCode', 'moduleLangCode', 'value','unit']">
          <template v-slot:moduleLangCode="scope">
            {{ compLanguageMap[scope.row.moduleLangCode] }}
          </template>
          <template v-slot:langCode="scope">
            {{ tslDataLanguageMap[scope.row.langCode] }}
          </template>
          <template v-slot:value="scope">
            <template v-if="scope.row.dicGroup && scope.row.dicGroup !== '-' && scope.row.value !== 'null'">
              {{ getDicValue(scope.row.dicGroup, scope.row.value) }}
            </template>
            <template v-else-if="scope.row.unit==='℃'">
              {{ $celsiusToFahrenheit(scope.row.value) }}
            </template>
            <template v-else>
              {{ scope.row.value }}
            </template>
          </template>
          <template v-slot:unit="scope">
            {{scope.row.unit==='℃'?$formatTempUnit():getDicValue('iot_tsl_data_unit', scope.row.unit, 'value')}}
          </template>
          <template v-slot:isNormal="scope">
            <el-radio-group v-model="scope.row.isNormal" @change="onNormalChange($event, scope.$index)">
              <el-radio :label="1">{{ $t('dms_device_test_dialog.zheng_chang') }}</el-radio>
              <el-radio :label="0">{{ $t('dms_device_test_dialog.bu_zheng_chang') }}</el-radio>
            </el-radio-group>
          </template>
        </custom-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onRreject">{{ $t('dms_device_test_dialog.bu_tong_guo') }}</el-button>
      <el-button type="primary" @click="onPass">{{ $t('dms_device_test_dialog.tong_guo') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      temp: undefined,
      testTime: null,
      modemSnInfo: {},
      col: [],
      tableList: [],
      col1Config: {},
      col2Config: {},
      tableCode: 'device_test_report',

      compLanguageMap: {},
      tslDataLanguageMap: {},
      asyncing: false,
    };
  },
  mounted() {
    this.getTableColumn();
    this.getDictionary('device_test_report_header', (data) => {
      const col = data.device_test_report_header.map(item => ({
        columnCode: item.value,
        columnName: item.name,
        selected: true,
      }));
      this.col = col;
    });
    this.getLanguageMap();
    this.init();
  },
  methods: {
    valueFileter(val) {
      const arr = [null, 'null', undefined, ''];
      return arr.includes(val) ? '-' : val;
    },
    init(refresh = false) {
      this.$getJSON(apis.modemBatteryInfo, {
        modemSn: this.model.data.modemSn,
      }).then((res) => {
        this.modemSnInfo = res.data;
      });
      this.$getJSON(apis.DeviceTestReportGenerate, {
        modemSn: this.model.data.modemSn,
        testType: this.model.data.testType,
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.isNormal = '';
        });
        this.tableList = res.data;
        this.nullValueToCrossbar(this.tableList, ['isNormal', 'value']);
        this.getCol1Config();
        if (refresh) {
          this.$message({
            type: 'success',
            message: this.$t('dms_device_test_dialog.shua_xin_cheng_gong'),
          });
        }
      });
    },
    refreshPage() {
      this.init(true);
    },
    // 特殊表格列多语言翻译
    getLanguageMap() {
      // 产品部件（测试模块）
      this.$getJSON(apis.LanguagePlatform, {
        keyGroupCode: 'iot_component_lang',
      }).then((res) => {
        this.compLanguageMap = res.data;
      });
      // 物模型数据（测试项目）
      this.$getJSON(apis.LanguagePlatform, {
        keyGroupCode: 'iot_tsl_data_lang',
      }).then((res) => {
        this.tslDataLanguageMap = res.data;
      });
    },
    // 初始化合并单元格配置
    getCol1Config() {
      const list = this.$splitArrByKey(this.tableList, 'moduleLangCode');
      const ret = {};
      let index = 0;
      list.forEach((arr) => {
        const len = arr.length;
        ret[index] = len;
        index += len;
      });
      this.col1Config = ret;
    },
    // 选中值绑定
    onNormalChange(val, index) {
      const len = this.col1Config[index];
      for (let i = index; i < index + len; i++) {
        this.tableList[i].isNormal = val;
      }
    },
    // 合并列配置
    objectSpanMethod({ rowIndex, columnIndex }) {
      if ([1, 2, 6].includes(columnIndex)) {
        if (this.col1Config[rowIndex]) {
          return {
            rowspan: this.col1Config[rowIndex],
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    validate(cb) {
      if (this.tableList.some(item => ![0, 1].includes(item.isNormal))) {
        cb(false);
      } else {
        cb(true);
      }
    },
    // 不通过
    onRreject() {
      this.validate((val) => {
        if (!val) {
          this.$message.error(this.$t('dms_device_test_dialog.qxgxsfzc'));
        } else {
          if (!this.temp && this.temp !== 0) {
            this.$message.error(this.$t('dms_device_test_dialog.qxxzcssw'));
          } else {
            // 转换存储摄氏度
            const temp = this.$fahrenheitToCelsius(this.temp);
            this.$postJSON(apis.DeviceTestReportAdd, {
              envTemp: temp,
              modemBatteryId: this.model.data.modemBatteryId,
              modemSn: this.model.data.modemSn,
              testType: this.model.data.testType,
              reportData: JSON.stringify(this.tableList),
              reportState: 0,
              startTime: this.testTime && this.testTime[0] ? `${moment(this.testTime[0]).format('YYYY-MM-DD')} 00:00:00` : '',
              endTime: this.testTime && this.testTime[1] ? `${moment(this.testTime[1]).format('YYYY-MM-DD')} 23:59:59` : '',
            }).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.$emit('success');
              this.visible = false;
            });
          }
        }
      });
    },
    // 通过
    onPass() {
      this.validate((val) => {
        if (!val) {
          this.$message.error(this.$t('dms_device_test_dialog.qxgxsfzc'));
        } else {
          if (!this.temp && this.temp !== 0) {
            this.$message.error(this.$t('dms_device_test_dialog.qxxzcssw'));
          } else {
            // 转换存储摄氏度
            const temp = this.$fahrenheitToCelsius(this.temp);
            this.$postJSON(apis.DeviceTestReportAdd, {
              envTemp: temp,
              modemBatteryId: this.model.data.modemBatteryId,
              modemSn: this.model.data.modemSn,
              testType: this.model.data.testType,
              reportData: JSON.stringify(this.tableList),
              reportState: 1,
              startTime: this.testTime && this.testTime[0] ? `${moment(this.testTime[0]).format('YYYY-MM-DD')} 00:00:00` : '',
              endTime: this.testTime && this.testTime[1] ? `${moment(this.testTime[1]).format('YYYY-MM-DD')} 23:59:59` : '',
            }).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.$emit('success');
              this.visible = false;
            });
          }
        }
      });
    },
    // 刷新组件
    refreshCompoment: function () {
      this.$postJSON(`${apis.modemBatteryRefresh}/${this.model.data.modemSn}`).then(() => {
        this.asyncing = true;
        setTimeout(() => {
          this.asyncing = false;
          this.init();
        }, 30000);
      });
    },
  },
};
</script>

<style lang="scss">
.device-test-dialog {
  .el-table--border th,
  .el-table--border td {
    border-right: 1px solid #ebeef5 !important;
  }
  .el-table--border {
    border-left: 1px solid #ebeef5 !important;
    border-right: 1px solid #ebeef5 !important;
  }

  .table-bd .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #ffffff !important;
  }

  .el-dialog__body {
    height: calc(100% - 106px);
  }
  .el-dialog {
    margin: auto !important;
    height: 100%;
  }
  .device-header {
    line-height: 28px;
    font-size: 12px;
    overflow: hidden;
    .device-id {
      float: left;
      color: #495057;
      line-height: 32px;
    }
    .device-time {
      float: right;
      color: #495057;
      line-height: 32px;
    }
    .device-temp {
      float: right;
      color: #495057;
      font-weight: bold;
      .key {
        float: left;
        line-height: 32px;
      }
      .val {
        float: left;
        margin-left: 12px;
      }
    }
  }

  .dialog-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .table-bd {
    margin-top: 16px;
    height: 0;
    flex: 1;
  }

  // .el-dialog__footer {
  //   border-top: 1px solid #e9ebec;
  //   padding-top: 11px;
  //   padding-bottom: 11px;
  // }
}
</style>
